import * as D from '@docmaps/sdk';
import * as E from 'fp-ts/lib/Either';
import { pipe } from 'fp-ts/lib/function';
export const mapLeftToUnknownError = (m = 'unknown error in @docmaps/etl') => E.mapLeft((e) => {
    return new Error(`error: ${m}`, { cause: e });
});
export function nameForAuthor(a) {
    return a.name || (a.given ? `${a.family}, ${a.given}` : a.family);
}
export function stepArrayToDocmap(publisher, inputDoi, [firstStep, ...steps]) {
    const dm_id = `https://docmaps-project.github.io/ex/docmap_for/${inputDoi}`;
    const now = new Date();
    let bnodeId = 0;
    const dmBody = {
        type: 'docmap',
        id: dm_id,
        publisher: publisher,
        created: now,
        updated: now,
    };
    if (!firstStep) {
        const dmObject = D.Docmap.decode(dmBody);
        if (E.isLeft(dmObject)) {
            return E.left(new Error('unable to parse manuscript step', { cause: dmObject.left }));
        }
        return E.right([dmObject.right]);
    }
    const reduction = steps.reduce((memo, next) => {
        if (E.isLeft(memo)) {
            return memo;
        }
        const m = memo.right;
        const previousId = `_:b${bnodeId}`;
        bnodeId += 1;
        const thisId = `_:b${bnodeId}`;
        const prev = m[previousId];
        if (!prev) {
            return E.left(new Error(`algorithm error: step memo was missing step for id ${previousId} but was processing step with id ${thisId}`));
        }
        m[previousId] = {
            ...prev,
            'next-step': thisId,
        };
        m[thisId] = {
            ...next,
            'previous-step': previousId,
        };
        return E.right(m);
    }, E.right({
        '_:b0': firstStep,
    }));
    return pipe(reduction, E.map((r) => ({
        ...dmBody,
        'first-step': '_:b0',
        steps: r,
    })), E.chain((b) => pipe(b, D.Docmap.decode, mapLeftToUnknownError('decoding docmap'))), E.map((d) => [d]));
}
//# sourceMappingURL=index.js.map